var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptableUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.9708 2.925 17.0625C2.025 16.1542 1.3125 15.0917 0.7875 13.875C0.2625 12.6583 0 11.3667 0 10C0 7.38334 0.866667 5.13334 2.6 3.25C4.33333 1.36667 6.46667 0.300003 9 0.0500031V3.05C7.28333 3.28334 5.85417 4.05417 4.7125 5.3625C3.57083 6.67084 3 8.21667 3 10C3 11.9333 3.68333 13.5833 5.05 14.95C6.41667 16.3167 8.06667 17 10 17C11.1 17 12.1292 16.7667 13.0875 16.3C14.0458 15.8333 14.85 15.2 15.5 14.4L18.1 15.9C17.2 17.15 16.0417 18.1458 14.625 18.8875C13.2083 19.6292 11.6667 20 10 20ZM9 14V11H6V9H9V6H11V9H14V11H11V14H9ZM19.15 14.05L16.55 12.55C16.7 12.15 16.8125 11.7375 16.8875 11.3125C16.9625 10.8875 17 10.45 17 10C17 8.21667 16.4292 6.67084 15.2875 5.3625C14.1458 4.05417 12.7167 3.28334 11 3.05V0.0500031C13.5333 0.300003 15.6667 1.36667 17.4 3.25C19.1333 5.13334 20 7.38334 20 10C20 10.7333 19.9333 11.4417 19.8 12.125C19.6667 12.8083 19.45 13.45 19.15 14.05Z",
    fill: "#2181FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptableUsage);
export default __webpack_public_path__ + "static/media/acceptable-usage.4f779fdb20f3ca02ef18a903239a99d9.svg";
export { ForwardRef as ReactComponent };